export default __webpack_public_path__ + "static/media/id-icon.cc1d36ac.svg";